const TURKISH_CHAR_MAP = {
  ç: 'c', Ç: 'c',
  ğ: 'g', Ğ: 'g',
  ı: 'i', İ: 'i',
  ö: 'o', Ö: 'o',
  ş: 's', Ş: 's',
  ü: 'u', Ü: 'u',
};

export const toEmailLocalPart = (str) =>
  str
    .split('')
    .map((ch) => TURKISH_CHAR_MAP[ch] || ch)
    .join('')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
